import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { DOCUMENT, inject, Injectable } from '@angular/core';
import { PamInterceptor } from '@galaxy/atlas';
import { Observable } from 'rxjs';

@Injectable()
export class PublicRoutePamInterceptor extends PamInterceptor {
  private readonly document = inject(DOCUMENT);

  override intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Public pages (order approval, fulfillment forms) run with an anonymous or temporary
    // order-recipient session. Background calls that 403 there must not start a PAM access
    // check: the anonymous CanViewPlatformNamespace probe always denies, and its redirect to
    // the AuthGuard-protected location picker sends the router into an SSO navigation loop
    // that blanks the page on Safari (MT-4211). Checked against document.location because the
    // router URL is not committed yet for requests fired during bootstrap.
    if (this.document.location.pathname.startsWith('/public/')) {
      return next.handle(request);
    }
    return super.intercept(request, next);
  }
}
